export const IMAGES = {
  thirsteaLogo: "/thirstea-logo-white.png",
  portraitNavy: "https://customer-assets-jai6qajn.emergentagent.net/job_premium-bio/artifacts/ch977dlg_Gurpreet%20Paul%203.png",
  bookCover: "https://customer-assets-4nw71qhi.emergentagent.net/job_b40e6e61-443c-405e-8caa-3963ef7bb516/artifacts/valu1lrk_The_Franchise_Mindset_Cover%20Page%202.png",
  portraitGrey: "https://customer-assets-4nw71qhi.emergentagent.net/job_b40e6e61-443c-405e-8caa-3963ef7bb516/artifacts/w6fa6zeu_Gurpreet%20Paul%2013.png",
  headshot: "https://customer-assets-4nw71qhi.emergentagent.net/job_b40e6e61-443c-405e-8caa-3963ef7bb516/artifacts/ugos5tai_Gurpreet%20Paul%205.png",
  portraitBrown: "https://customer-assets-4nw71qhi.emergentagent.net/job_b40e6e61-443c-405e-8caa-3963ef7bb516/artifacts/4pj3dlpd_Gurpreet%20Paul%209.jpg",
  desk: "https://customer-assets-4nw71qhi.emergentagent.net/job_b40e6e61-443c-405e-8caa-3963ef7bb516/artifacts/4opr4o7u_Gurpreet%20Paul%2011.png",
};

export const LINKS = {
  linkedin: "https://www.linkedin.com/in/gurpreetpaulusa/",
  linkedinCompany: "https://www.linkedin.com/company/thirstea-usa",
  instagram: "https://www.instagram.com/thirstea_usa_/",
  amazon: "https://a.co/d/0htOTNKl",
  thirstea: "https://www.thirstea.com",
  pressRelease: "https://www.24-7pressrelease.com/press-release/537229",
  email: "Contact@thirstea.com",
};

export const JOURNEY = [
  {
    chapter: "01",
    era: "1994 — 1997",
    title: "The Foundation",
    role: "Education & Early Discipline",
    description:
      "A Bachelor's in Economics & Business (1994), an MBA from the Institute of Management Studies (1997), and an associate degree in International Sales & Export Management from IIEM Bangalore. The academic bedrock for everything that followed — business principles learned early, applied for a lifetime.",
    tags: ["MBA", "Economics & Business", "Export Management"],
  },
  {
    chapter: "02",
    era: "1997 — 2002",
    title: "Learning the Craft",
    role: "Reckitt Benckiser · PepsiCo",
    description:
      "Sales executive at Reckitt Benckiser, then customer executive at Pepsi Cola Co. Foundational years in sales, marketing and customer relations — learning how world-class consumer brands move product and win markets. In 2002, he immigrated to the United States.",
    tags: ["Sales", "Marketing", "Customer Relations"],
  },
  {
    chapter: "03",
    era: "2004 — 2017",
    title: "The Coca-Cola Years",
    role: "Channel Manager → Area Development Manager → Sales Manager",
    description:
      "Thirteen years inside one of the most recognized consumer brand companies in the world. Managed sales operations across Los Angeles and California, developed key accounts, led teams to significant revenue growth — and observed firsthand how a great brand maintains its standards across thousands of locations without losing its identity.",
    tags: ["Leadership", "Distribution", "Key Accounts", "Revenue Growth"],
  },
  {
    chapter: "04",
    era: "2017 — 2022",
    title: "The Entrepreneurial Era",
    role: "Founder & CEO — Star-Buffet Chain · Digify Media Agency · E-Commerce",
    description:
      "Founder and CEO of three ventures and President of Accelerated Services. Real experience, real failure and real growth across business development, strategic planning and operational management — the lessons no classroom ever teaches.",
    tags: ["Entrepreneurship", "Strategy", "Operations"],
  },
  {
    chapter: "05",
    era: "2023 — Present",
    title: "ThirsTea USA",
    role: "Founder & Chief Executive Officer",
    description:
      "Founder and CEO of ThirsTea USA — one of America's fastest-growing specialty beverage and boba tea franchise brands. He transformed the boba tea industry by addressing operational and service gaps, building franchise systems, training protocols and brand standards before scale — now expanding across US states with international franchise opportunities underway in India, Canada, Mexico and the Middle East.",
    tags: ["Franchising", "Brand Building", "Global Expansion"],
  },
];

export const AWARDS = [
  {
    year: "2026",
    title: "Marquis Who's Who in America",
    detail:
      "Honored for leadership in franchising, entrepreneurship, business and brand development worldwide in the beverage industry. Selected on the basis of current reference value — position, noteworthy accomplishments, visibility and prominence in the field.",
    link: LINKS.pressRelease,
    linkLabel: "Read the press release",
    badge: "/badge-marquis.png",
    badgeClass: "h-32 lg:h-40",
  },
  {
    year: "2026",
    title: "The Global Icon of Impact Award",
    detail:
      "Honored with The Global Icon of Impact Award for Excellence in Beverage & Franchising 2026 — recognizing transformative leadership and lasting impact across the global beverage and franchising landscape.",
  },
  {
    year: "2026",
    title: "CIO World Magazine — Iconic Founders & CEOs To Watch",
    detail:
      "Featured by CIO World Magazine among the Top Most Iconic Founders & CEOs To Watch 2026, spotlighting visionary leadership, brand-building excellence and the entrepreneurs shaping what comes next.",
  },
  {
    year: "2026",
    title: "Entrepreneur Magazine — Top 150 New Franchises",
    detail:
      "ThirsTea USA ranked #47 among new and emerging United States brands — a Top 150 Franchise in Entrepreneur's Franchise 500 ranking. Franchising since 2023, with a startup cost of $213.3K–$291.4K as published in the official 2026 listing.",
    rank: "#47",
    badge: "/entrepreneur-top150.png",
    badgeLink: "/entrepreneur-top150.pdf",
    badgeClass: "h-36 lg:h-44",
  },
  {
    year: "2026",
    title: "Franchise Voice — Top 100 Influencers",
    detail:
      "Ranked #55 in the Top 100 Influencers by Franchise Voice, recognizing impact and thought leadership across the franchising industry.",
    rank: "#55",
    badge: "/badge-franchise-voice.jpg",
    badgeClass: "h-36 lg:h-44 rounded-lg",
  },
  {
    year: "2025 · 2026",
    title: "Fran-Tastic Brand of the US — FranServe",
    detail:
      "ThirsTea USA was awarded the Fran-Tastic Brand of the US in 2025 and again in 2026 by FranServe — back-to-back recognition of franchise excellence and brand momentum.",
    badge: "/badge-franserve.png",
    badgeClass: "h-32 lg:h-36",
  },
  {
    year: "Ongoing",
    title: "President — Asian Business Resource Group, Southern California",
    detail:
      "Reflecting a deep commitment to supporting Asian business professionals and fostering community engagement — alongside active charitable initiatives within the Indian community.",
  },
];

export const BOOK_LESSONS = [
  "Revenue solves few problems. Profit solves many.",
  "Systems create freedom.",
  "Hire slowly, train continuously and lead consistently.",
  "The greatest risk in entrepreneurship is not failing. It is failing to start.",
];

export const PRESS_BIO_SHORT =
  "Gurpreet Paul is the Founder & CEO of ThirsTea USA, one of America's fastest-growing specialty beverage and boba tea franchise brands, and the author of The Franchise Mindset (2026). A 2026 Marquis Who's Who in America honoree, he has spent three decades building brands across PepsiCo, Coca-Cola and his own ventures.";

export const PRESS_BIO_LONG =
  "Born in India, Gurpreet Paul immigrated to the United States in 2002 after earning his MBA from the Institute of Management Studies and beginning his career at Reckitt Benckiser and Pepsi Cola Co. He went on to spend thirteen years at The Coca-Cola Company — rising from channel manager to area development manager to sales manager — where he learned firsthand how a great brand maintains its standards at scale. In 2017 he founded Star-Buffet Chain, Digify Media Agency and an e-commerce venture, and served as President of Accelerated Services. In 2023 he founded ThirsTea USA, transforming the boba tea industry by addressing operational and service gaps, and building franchise systems, training protocols and brand standards before scale. Under his leadership, ThirsTea was ranked #47 on Entrepreneur magazine's Top 150 New Franchises and he was ranked #55 among Franchise Voice's Top 100 Influencers. In 2026 he was selected for inclusion in Marquis Who's Who in America, received The Global Icon of Impact Award for Excellence in Beverage & Franchising, and was featured by CIO World Magazine among the Top Most Iconic Founders & CEOs To Watch. His first book, The Franchise Mindset, chronicles the full journey with honesty — and a framework any entrepreneur can apply. He serves as President of the Asian Business Resource Group of Southern California, and lives and works in California.";

export const PRESS_ASSETS = [
  { label: "Executive Portrait", src: IMAGES.headshot },
  { label: "At ThirsTea HQ", src: IMAGES.portraitGrey },
  { label: "Official Headshot", src: IMAGES.portraitBrown },
  { label: "Editorial Portrait", src: IMAGES.desk },
  { label: "Book Cover", note: "The Franchise Mindset (2026)", src: IMAGES.bookCover },
  { label: "ThirsTea USA Logo", note: "Dark-background version (PNG)", src: IMAGES.thirsteaLogo, contain: true },
];
